<template>
  <section class="dp-layout parking-page parking-vehicle-page">
    <section class="dp-right">
      <toolbar ref="toolbar" :buttonList="buttonList" :searchList="searchList" @callFunction="callFunction"></toolbar>

      <div class="parking-stat-wrap">
        <div class="parking-stat-cards cols-4" :class="{ 'is-summary-loading': loading }">
          <div class="parking-stat-card stat-total clickable" :class="{ active: !subjectType }" @click="quickFilter('')">
            <div class="stat-card-head">
              <span class="stat-card-icon"><i class="el-icon-s-data"></i></span>
              <span class="stat-card-label">车牌总数</span>
            </div>
            <div class="stat-card-value">{{ summary.totalPlateCount }}</div>
          </div>
          <div class="parking-stat-card stat-entry clickable" :class="{ active: subjectType === 'Parent' }" @click="quickFilter('Parent')">
            <div class="stat-card-head">
              <span class="stat-card-icon"><i class="el-icon-user"></i></span>
              <span class="stat-card-label">家长车牌 · {{ summary.parentSubjectCount }} 位监护人</span>
            </div>
            <div class="stat-card-value">{{ summary.parentPlateCount }}</div>
          </div>
          <div class="parking-stat-card stat-plates clickable" :class="{ active: subjectType === 'Teacher' }" @click="quickFilter('Teacher')">
            <div class="stat-card-head">
              <span class="stat-card-icon"><i class="el-icon-s-custom"></i></span>
              <span class="stat-card-label">教师车牌 · {{ summary.teacherSubjectCount }} 位教师</span>
            </div>
            <div class="stat-card-value">{{ summary.teacherPlateCount }}</div>
          </div>
          <div class="parking-stat-card stat-duration">
            <div class="stat-card-head">
              <span class="stat-card-icon"><i class="el-icon-truck"></i></span>
              <span class="stat-card-label">
                维护主体
                <el-tooltip content="按监护人/教师聚合后的人数，每人可维护多辆车。" placement="top">
                  <i class="el-icon-question stat-tip-icon"></i>
                </el-tooltip>
              </span>
            </div>
            <div class="stat-card-value">{{ summary.parentSubjectCount + summary.teacherSubjectCount }}</div>
          </div>
        </div>
      </div>

      <div class="parking-table-panel">
        <div class="panel-header">
          <div class="panel-title">师生长期车牌<span class="count">共 {{ total }} 位车主</span></div>
          <span class="panel-tip">后台直改不受家长/教师数量配置限制，保存后自动同步车场白名单</span>
        </div>

        <div class="tbl-scroll-host">
          <el-table :data="rows" v-loading="loading" class="custom-tbl" style="width:100%" height="100%">
            <el-table-column type="index" label="序号" width="60" :index="rowIndex"></el-table-column>
            <el-table-column label="类型" width="90">
              <template slot-scope="scope">
                <span :class="['subject-tag', scope.row.subjectType === 'Parent' ? 'is-parent' : 'is-teacher']">
                  {{ scope.row.subjectType === 'Parent' ? '家长' : '教师' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="车主" min-width="130">
              <template slot-scope="scope">{{ scope.row.ownerName || '-' }}</template>
            </el-table-column>
            <el-table-column label="关联学生" min-width="130">
              <template slot-scope="scope">
                <span v-if="scope.row.subjectType === 'Parent'">{{ scope.row.studentName || '-' }}</span>
                <span v-else class="text-muted">-</span>
              </template>
            </el-table-column>
            <el-table-column label="长期车牌" min-width="320">
              <template slot-scope="scope">
                <div class="plate-list">
                  <span v-for="item in scope.row.vehicles" :key="item.plateNo" class="plate-no-badge">{{ item.plateNo }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="车牌数" width="80" align="center">
              <template slot-scope="scope">{{ scope.row.vehicles.length }}</template>
            </el-table-column>
            <el-table-column v-if="can('openEdit')" label="操作" width="90" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-col :span="24" class="toolbar">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="page"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            style="float:right"
          ></el-pagination>
        </el-col>
      </div>
    </section>

    <el-dialog
      :title="editing.isNew ? (editing.subjectType === 'Parent' ? '录入家长车牌' : '录入教师车牌') : '维护长期车牌'"
      :visible.sync="dialogVisible"
      width="560px"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form label-width="80px" size="small">
        <template v-if="editing.isNew && editing.subjectType === 'Teacher'">
          <el-form-item label="教职工" required>
            <div class="parking-picked-row">
              <span v-if="editing.teacherId" class="picked-name">已选 {{ editing.ownerName }}</span>
              <span v-else class="picked-empty">请选择一名教职工</span>
              <el-button size="small" icon="el-icon-user" @click="openPicker('internal')">选择教职工</el-button>
            </div>
          </el-form-item>
        </template>
        <template v-else-if="editing.isNew && editing.subjectType === 'Parent'">
          <el-form-item label="学生" required>
            <div class="parking-picked-row">
              <span v-if="editing.studentId" class="picked-name">已选 {{ editing.studentName }}</span>
              <span v-else class="picked-empty">请选择一名学生</span>
              <el-button size="small" icon="el-icon-user" @click="openPicker('teaching')">选择学生</el-button>
            </div>
          </el-form-item>
          <el-form-item label="监护人" required>
            <el-select
              v-model="editing.parentId"
              :disabled="!editing.studentId"
              :loading="parentLoading"
              :placeholder="editing.studentId ? '请选择监护人' : '请先选择学生'"
              style="width:100%"
              @change="onParentChange"
            >
              <el-option
                v-for="item in parentOptions"
                :key="item.parentId"
                :value="item.parentId"
                :label="`${item.parentName}${item.relation ? '（' + item.relation + '）' : ''}${item.mobile ? ' ' + item.mobile : ''}`"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item v-else label="车主">
          <span class="picked-name">
            {{ editing.subjectType === 'Parent' ? `${editing.studentName} / ${editing.ownerName}` : editing.ownerName }}
          </span>
        </el-form-item>

        <el-form-item label="车牌" v-loading="existingLoading">
          <div v-for="(item, index) in editing.vehicles" :key="index" class="parking-plate-edit-row">
            <plate-no-input v-model="item.plateNo" class="plate-input" placeholder="请输入车牌号"></plate-no-input>
            <el-input v-model="item.vehicleType" placeholder="车型（可选）" style="width:130px"></el-input>
            <el-button type="text" class="is-danger" @click="editing.vehicles.splice(index, 1)">删除</el-button>
          </div>
          <el-button type="text" icon="el-icon-plus" @click="editing.vehicles.push({ plateNo: '', vehicleType: '' })">
            添加车牌
          </el-button>
          <div class="parking-form-tip">保存为整组覆盖：列表中删除的车牌会同步从车场白名单移除</div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </span>
    </el-dialog>

    <person-scope-picker-dialog
      :visible.sync="pickerVisible"
      :directory-scope="pickerScope"
      :show-scope-tabs="false"
      :scope-department-id="schoolId || 0"
      :value="pickerScope === 'internal' ? (editing.teacherId || null) : (editing.studentId || null)"
      :label="pickerScope === 'internal' ? editing.ownerName : editing.studentName"
      @confirm="onPicked"
    />
  </section>
</template>

<script>
import Toolbar from '@/components/Toolbar'
import PersonScopePickerDialog from '@/components/PersonScopePickerDialog'
import PlateNoInput from '@/components/PlateNoInput'
import {
  getParkingManageVehiclePage,
  getParkingStudentParents,
  saveParkingManageVehicles
} from '@/api/parking'
import { toCamel, loadButtonFuncs, buildToolbarButtons } from './parkingUtils'

const TOOLBAR_BUTTONS = [
  { name: '查询', Func: 'handleSearchBtn', icon: 'el-icon-search', always: true },
  { name: '新增教师车牌', Func: 'openCreateTeacher', icon: 'el-icon-plus', btnType: 'primary' },
  { name: '新增家长车牌', Func: 'openCreateParent', icon: 'el-icon-plus', btnType: 'primary' }
]

export default {
  name: 'ParkingVehicleManagement',
  components: { Toolbar, PersonScopePickerDialog, PlateNoInput },
  data() {
    return {
      schoolId: null,
      loading: false,
      saving: false,
      rows: [],
      total: 0,
      page: 1,
      pageSize: 10,
      pageSizes: [10, 20, 50, 100],
      keyword: '',
      subjectType: '',
      summary: { totalPlateCount: 0, parentPlateCount: 0, teacherPlateCount: 0, parentSubjectCount: 0, teacherSubjectCount: 0 },
      dialogVisible: false,
      editing: this.emptyEditing(),
      pickerVisible: false,
      pickerScope: 'internal',
      parentOptions: [],
      parentLoading: false,
      existingLoading: false,
      buttonFuncs: [],
      buttonList: [],
      searchList: [
        { key: 'keyword', label: '关键字', placeholder: '车牌/车主/学生', width: '180px' },
        {
          key: 'subjectType', label: '类型', type: 'select', clearable: true, initValue: '', width: '110px',
          options: [
            { value: '', label: '全部' },
            { value: 'Parent', label: '家长' },
            { value: 'Teacher', label: '教师' }
          ]
        }
      ]
    }
  },
  watch: {
    '$store.state.activeSchoolId': {
      immediate: true,
      handler(value) {
        this.schoolId = value
        this.page = 1
        if (value) this.load()
      }
    }
  },
  created() {
    this.buttonFuncs = loadButtonFuncs(this.$route.path)
    this.buttonList = buildToolbarButtons(TOOLBAR_BUTTONS, this.buttonFuncs)
  },
  methods: {
    /** 当前角色是否分配了该按钮权限 */
    can(func) {
      return this.buttonFuncs.includes(func)
    },
    callFunction(item) {
      if (item.Func && typeof this[item.Func] === 'function') this[item.Func](item)
    },
    emptyEditing() {
      return { isNew: false, subjectType: 'Teacher', studentId: 0, parentId: null, teacherId: 0, studentName: '', ownerName: '', vehicles: [] }
    },
    rowIndex(index) {
      return (this.page - 1) * this.pageSize + index + 1
    },
    handleSearchBtn(item) {
      const s = (item && item.search) || {}
      this.keyword = s.keyword || ''
      this.subjectType = s.subjectType || ''
      this.page = 1
      this.load()
    },
    quickFilter(type) {
      if (this.subjectType === type) return
      this.subjectType = type
      this.page = 1
      const toolbar = this.$refs.toolbar
      if (toolbar && toolbar.searchObj) this.$set(toolbar.searchObj, 'subjectType', type)
      this.load()
    },
    async load() {
      if (!this.schoolId) return
      this.loading = true
      try {
        const res = await getParkingManageVehiclePage({
          schoolId: this.schoolId,
          subjectType: this.subjectType,
          keyword: this.keyword,
          page: this.page,
          pageSize: this.pageSize
        })
        if (res.data && res.data.success) {
          const data = toCamel(res.data.response || {})
          this.rows = (data.data || []).map(x => ({ ...x, vehicles: x.vehicles || [] }))
          this.total = data.dataCount || 0
          this.summary = {
            totalPlateCount: data.totalPlateCount || 0,
            parentPlateCount: data.parentPlateCount || 0,
            teacherPlateCount: data.teacherPlateCount || 0,
            parentSubjectCount: data.parentSubjectCount || 0,
            teacherSubjectCount: data.teacherSubjectCount || 0
          }
        } else {
          this.$message.error((res.data && res.data.msg) || '车牌列表加载失败')
        }
      } catch (e) {
        this.$message.error('车牌列表加载失败')
      } finally {
        this.loading = false
      }
    },
    handleCurrentChange(val) {
      this.page = val
      this.load()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.page = 1
      this.load()
    },
    openEdit(row) {
      this.editing = { ...this.emptyEditing(), ...JSON.parse(JSON.stringify(row)), isNew: false }
      this.dialogVisible = true
    },
    openCreateTeacher() {
      this.openCreate('Teacher')
    },
    openCreateParent() {
      this.openCreate('Parent')
    },
    openCreate(subjectType) {
      if (!this.schoolId) {
        this.$message.warning('请先选择学校')
        return
      }
      this.editing = { ...this.emptyEditing(), isNew: true, subjectType, vehicles: [{ plateNo: '', vehicleType: '' }] }
      this.parentOptions = []
      this.dialogVisible = true
    },
    openPicker(scope) {
      this.pickerScope = scope
      this.pickerVisible = true
    },
    /** 通讯录选人回调：教师直接加载现有车牌；学生加载监护人列表 */
    async onPicked(person) {
      if (!person) return
      if (this.pickerScope === 'internal') {
        this.editing.teacherId = Number(person.id) || 0
        this.editing.ownerName = person.name || ''
        await this.loadExistingPlates()
        return
      }
      this.editing.studentId = Number(person.id) || 0
      this.editing.studentName = person.name || ''
      this.editing.parentId = null
      this.editing.ownerName = ''
      this.resetVehicles()
      this.parentOptions = []
      this.parentLoading = true
      try {
        const res = await getParkingStudentParents({ schoolId: this.schoolId, studentId: this.editing.studentId })
        if (res.data && res.data.success) {
          this.parentOptions = toCamel(res.data.response || [])
          if (!this.parentOptions.length) {
            this.$message.warning('该学生暂无监护人，请先维护监护人信息')
          } else if (this.parentOptions.length === 1) {
            this.editing.parentId = this.parentOptions[0].parentId
            await this.onParentChange(this.editing.parentId)
          }
        } else {
          this.$message.error((res.data && res.data.msg) || '监护人加载失败')
        }
      } finally {
        this.parentLoading = false
      }
    },
    async onParentChange(parentId) {
      const parent = this.parentOptions.find(x => x.parentId === parentId)
      this.editing.ownerName = parent ? parent.parentName : ''
      await this.loadExistingPlates()
    },
    /** 清空车牌列表为一行空白，切换车主时调用，避免上一个车主的车牌残留。创建于 2026-10-10 */
    resetVehicles() {
      this.editing.vehicles = [{ plateNo: '', vehicleType: '' }]
    },
    /** 录入时回填该车主已有车牌，避免整组保存时误覆盖；先清空再回填 */
    async loadExistingPlates() {
      this.resetVehicles()
      const { subjectType, teacherId, parentId, ownerName } = this.editing
      const ownerId = subjectType === 'Teacher' ? teacherId : parentId
      const seq = (this.plateLoadSeq = (this.plateLoadSeq || 0) + 1)
      if (!ownerId || !ownerName) return
      this.existingLoading = true
      try {
        const res = await getParkingManageVehiclePage({
          schoolId: this.schoolId,
          subjectType,
          keyword: ownerName,
          page: 1,
          pageSize: 200
        })
        if (seq !== this.plateLoadSeq) return
        const data = toCamel((res.data && res.data.response) || {})
        const hit = (data.data || []).find(x =>
          subjectType === 'Teacher' ? x.teacherId === ownerId : x.parentId === ownerId)
        if (hit && hit.vehicles && hit.vehicles.length) {
          this.editing.vehicles = hit.vehicles.map(v => ({ plateNo: v.plateNo, vehicleType: v.vehicleType || '' }))
          this.$message.info(`已回填该车主现有 ${hit.vehicles.length} 辆车，可在此基础上调整`)
        }
      } finally {
        if (seq === this.plateLoadSeq) this.existingLoading = false
      }
    },
    async save() {
      const { subjectType, studentId, parentId, teacherId } = this.editing
      if (subjectType === 'Teacher' && !teacherId) {
        this.$message.warning('请选择教职工')
        return
      }
      if (subjectType === 'Parent' && (!studentId || !parentId)) {
        this.$message.warning('请选择学生和监护人')
        return
      }
      const items = this.editing.vehicles
        .filter(x => (x.plateNo || '').trim())
        .map(x => ({ plateNo: x.plateNo.trim(), vehicleType: (x.vehicleType || '').trim() }))
      if (!items.length) {
        try {
          await this.$confirm('未填写任何车牌，保存后将清空该车主全部长期车牌，确定继续吗？', '提示', { type: 'warning' })
        } catch (e) {
          return
        }
      }
      this.saving = true
      try {
        const res = await saveParkingManageVehicles({
          schoolId: this.schoolId,
          subjectType,
          studentId,
          parentId,
          teacherId,
          items
        })
        if (res.data && res.data.success) {
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.load()
        } else {
          this.$message.error((res.data && res.data.msg) || '保存失败')
        }
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style>
@import './parking-page.css';
</style>
